export const MODAL_TYPE_REPORT_POST = 'report-post';
